import { Validators, FormBuilder } from '@angular/forms';

export let INN_LENGTH_REGEXP = /^(([0-9]{10})|([0-9]{12}))$/;

export let loginValidationMessages: {} = {
  username: {
    'required': 'Данное поле обязательно для заполнения.',
    'pattern': 'Данное поле должно содержать 10 или 12 цифр.',
  },
  password: {
    'required': 'Данное поле обязательно для заполнения.',
    'minlength': 'Длина ввода должна быть не менее 5 символов.',
    'maxlength': 'Длина ввода не может превышать 191 символов.'
  },
};

export function getLoginControlsConfig(model, fb: FormBuilder) {
  return {
    username: [model.username, [Validators.required]],
    password: [model.password, [Validators.required, Validators.minLength(5), Validators.maxLength(191)]],
  };
}



// WEBPACK FOOTER //
// ./src/app/components/home/login.form.ts